import type { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { from, type Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { getRequestDomainInfo } from '../../helpers/request.helper';
import { AuthService } from '../auth.service';

@Injectable()
export class AuthHttpInterceptor implements HttpInterceptor {
  private _authService = inject(AuthService);

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // we retrieve the token, if any
    return from(this._authService.getAccessToken()).pipe(
      switchMap((accessToken) => {
        const { isAppUrl } = getRequestDomainInfo(req);

        // make sure token is only being added for internal apps
        let newHeaders = req.headers;
        if (accessToken && isAppUrl) {
          // if we have a token, we append it to our new headers
          newHeaders = newHeaders.append('Authorization', `Bearer ${accessToken}`);
        }

        // finally we have to clone our request with our new headers (HttpRequests are immutable)
        const authReq = req.clone({ headers: newHeaders });

        // return an Observable that will run the request
        // or pass it to the next interceptor if any
        return next.handle(authReq);
      })
    );
  }
}
